import type { DefaultRemoteConfig, AppRemoteConfig } from './types';

/**
 * @description Default config to pass when initializing firebase/remote-config
 *
 * @see https://firebase.google.com/docs/remote-config/get-started?hl=en&authuser=0&platform=web#default-parameter-in-app
 */
const defaultRemoteConfig: DefaultRemoteConfig = {
  tours_maintenance_toaster: '',
  tours_flash_sale_config: '',
};

const defaultAppRemoteConfig: AppRemoteConfig = {
  tours_maintenance_toaster: null,
  tours_flash_sale_config: {
    startDate: '2026-10-07T00:00:00+05:00',
    endDate: '2026-10-09T23:59:59+05:00',
  },
};

export const firebaseConfig = {
  defaultRemoteConfig,
  defaultAppRemoteConfig,
};
